import * as React from 'react';

import { Paper, LinearProgress, Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import { ResponsiveContainer, BarChart, XAxis, Legend, Bar, YAxis, CartesianGrid, Tooltip } from 'recharts';
import { ICardBarChartMarketAndGroupAndBookstoreDataChart
    , CustonTooltipDataCardBarChartMarketAndGroupAndBookstore
    , convertDataCardBarChartMarketAndGroupAndBookstore } from './CardBarChartMarketAndGroupAndBookstore';

// statless component
const MarketShareBookstoreCategoryPNShareChartModal = ({ data }: { data: ICardBarChartMarketAndGroupAndBookstoreDataChart[] }) => (
    <ResponsiveContainer width="100%" height={345}>
        <BarChart data={data} margin={{ top: 15, right: 20, left: 20, bottom: 80 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis interval={0} dataKey="desc"  tick={{fontSize: 10, angle: -90, dx: -3, dy: 50}}/>
            <YAxis  yAxisId="only" hide={true} />
            <Tooltip content={<CustonTooltipDataCardBarChartMarketAndGroupAndBookstore isAnimationActive={false}  />} />
            <Legend verticalAlign="top" height={20}/>
            <Bar yAxisId="only" dataKey="marketSalesPercent" name="Mercado" fill="#65cc93" />
            <Bar yAxisId="only" dataKey="groupSalesPercent" name="Rede de lojas" fill="#323232" />
            <Bar yAxisId="only" dataKey="storeSalesPercent" name="Lojas" fill="#FF6A14" />
        </BarChart>
    </ResponsiveContainer>
);

// tslint:disable-next-line:no-empty-interface
interface ICardBarChartMarketAndGroupAndBookstoreModalProps {
    data: any;
    loading: boolean;
    type: string;
}

// tslint:disable-next-line:no-empty-interface
interface ICardBarChartMarketAndGroupAndBookstoreModalState {
    dialogOpen: boolean
}

export class CardBarChartMarketAndGroupAndBookstoreModal extends React.Component<ICardBarChartMarketAndGroupAndBookstoreModalProps, ICardBarChartMarketAndGroupAndBookstoreModalState> {

    constructor(props: ICardBarChartMarketAndGroupAndBookstoreModalProps) {
        super(props);
        this.state = {
            dialogOpen: false
        }
    }

    public render() {
        return (
            <div className="filter-item">
                <Button onClick={this.handleDialogOpen} color="primary">
                    Ver Mais
                </Button>
                <Dialog
                    fullScreen={true}
                    open={this.state.dialogOpen}
                    onClose={this.handleDialogClose}
                    aria-labelledby="economic-group-dialog-title"
                    aria-describedby="alereconomic-group-dialog-description"
                    className="filter-dialog">
                    <DialogTitle className="filter-dialog-title" id="economic-group-dialog-title">
                        {this.props.type +" Vendas por Tema (BISAC) - 30 Dias"}
                    </DialogTitle>
                    <DialogContent className="filter-dialog-content">
                        <Paper className="publisher-sale-block panel-block" >
                            {this.props.loading && <LinearProgress />}
                            {this.props.data && (
                                <MarketShareBookstoreCategoryPNShareChartModal 
                                    data={convertDataCardBarChartMarketAndGroupAndBookstore(this.props.data, this.props.type, true)} 
                                />
                            )}
                        </Paper>
                    </DialogContent>
                    <DialogActions className="filter-actions">
                        <Button className="filter-dialog-close" onClick={this.handleDialogClose} >
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }

    private handleDialogOpen = () => {
        this.setState({ dialogOpen: true });
    };

    private handleDialogClose = () => {
        this.setState({ dialogOpen: false });
    };
}


// WEBPACK FOOTER //
// ./src/component/shared/layout/components/CardBarChartMarketAndGroupAndBookstoreModal.tsx